export enum StatusViagem {
  FINALIZADA = "FINALIZADA",
  INICIADA = "INICIADA",
}
